import { Team } from "common";

export const DEFAULT_TEAM: Team = {
  id: 0,
  location: "detroit",
  name: "lions",
  abbreviation: "det",
  conference: "nfc",
  division: "north",
  primaryColor: "#0076b6",
  secondaryColor: "#B0B7BC",
  tertiaryColor: "#000000",
  logoUrl: "/images/teams/Team=DET.svg",
};

export const TEAMS: Team[] = [
  {
    id: 0,
    location: "Buffalo",
    name: "Bills",
    abbreviation: "BUF",
    conference: "nfc",
    division: "north",
    primaryColor: "#0076b6",
    secondaryColor: "#B0B7BC",
    tertiaryColor: "#000000",
    logoUrl: "/images/teams/Team=BUF.svg",
  },
  {
    id: 1,
    location: "Detroit",
    name: "Lions",
    abbreviation: "DET",
    conference: "nfc",
    division: "east",
    primaryColor: "#004C54",
    secondaryColor: "#A5ACAF",
    tertiaryColor: "#ACC0C6",
    logoUrl: "/images/teams/Team=DET.svg",
  },
  {
    id: 2,
    location: "Miami",
    name: "Dolphins",
    abbreviation: "MIA",
    conference: "nfc",
    division: "east",
    primaryColor: "#0B2265",
    secondaryColor: "#a71930",
    tertiaryColor: "#a5acaf",
    logoUrl: "/images/teams/Team=MIA.svg",
  },
  {
    id: 3,
    location: "Denver",
    name: "Broncos",
    abbreviation: "DEN",
    conference: "afc",
    division: "west",
    primaryColor: "#FB4F14",
    secondaryColor: "#002244",
    tertiaryColor: "",
    logoUrl: "/images/teams/Team=DEN.svg",
  },
  {
    id: 4,
    location: "Minnesota",
    name: "Vikings",
    abbreviation: "MIN",
    conference: "nfc",
    division: "north",
    primaryColor: "#4F2683",
    secondaryColor: "#FFC62F",
    tertiaryColor: "",
    logoUrl: "/images/teams/Team=MIN.svg",
  },
];
